import * as types from '../mutation-types'

export default {
	namespaced: true,

	state: {
		visits: [],
		workDaysStats: {}
	},

	actions: {
		fetchAll({ commit }, { day }) {
			return window.axios.get('/visits/mine', { params: { day } })
				.then((response) => {
					commit(types.STORE_VISITS, response.data);
					return response.data;
				})
		},

		checkLocation({ commit }, { entityId, latitude, longitude }) {
			return window.axios.get('/visits/checkVisitLocation', {
				params: {
					entityId,
					latitude,
					longitude
				}
			})
				.then((response) => response.data)
		},

		fetchAllData({ commit }, { day }) {
			return window.axios.get('/visits/mine/All', { params: { day } })
				.then((response) => {
					commit(types.STORE_VISITS, response.data);
					return response.data;
				})
		},

		fetchAllDueDates({ commit }, { fromDate, toDate }) {
			return window.axios.get('/visits/mine/All/betweenTwoDates', { params: { fromDate, toDate } })
				.then((response) => response.data)
		},

		fetchById({ commit }, { id }) {
			return window.axios.get(`/visits/${id}`)
				.then((response) => {
					return response.data;
				})
		},

		create({ commit }, { entityId, coreMessage, durationInMinutes, otherSamples, notes, objections, nextVisitNotes, purpose, materialAmounts, unavailableMaterialIds, competitiveSamples, residentDoctorNames, payment, amountReceived, createdAt, priceTypeId }) {
			return window.axios.post('/visits/createvisit', {
				entityId,
				coreMessage,
				durationInMinutes,
				otherSamples,
				notes,
				objections,
				nextVisitNotes,
				purpose,
				materialAmounts,
				unavailableMaterialIds,
				competitiveSamples,
				residentDoctorNames,
				payment,
				amountReceived,
				createdAt,
				priceTypeId
			})
		},

		update({ commit }, { id, entityId, coreMessage, durationInMinutes, otherSamples, notes, objections, nextVisitNotes, purpose, materialAmounts, unavailableMaterialIds, competitiveSamples, residentDoctorNames, payment, amountReceived, createdAt, priceTypeId }) {
			return window.axios.put(`/visits/${id}`, {
				entityId,
				coreMessage,
				durationInMinutes,
				otherSamples,
				notes,
				objections,
				nextVisitNotes,
				purpose,
				materialAmounts,
				unavailableMaterialIds,
				competitiveSamples,
				residentDoctorNames,
				payment,
				amountReceived,
				createdAt,
				priceTypeId
			})
		},

		delete({ commit }, { id }) {
			return window.axios.delete(`/visits/${id}`);
		},

		reset({ commit }) {
			commit(types.RESET_VISITS);
		},

		printInvoice({ commit }, { visitId, posDevice }) {
			return window.axios.get(`/reports/invoice/visit/${visitId}`, {
				params: { posDevice },
				responseType: 'blob',
				preventHandling: true // منع معالجة الـ response تلقائياً
			})
		},

		fetchWorkDaysStats({ commit }, { employeeId, fromDate, toDate }) {
			return window.axios.get('/visits/workDaysStats', { params: { employeeId, fromDate, toDate } })
				.then((response) => {
					commit(types.STORE_WORK_DAYS_STATS, response.data);
					return response.data;
				})
		},

		resetWorkDaysStats({ commit }) {
			commit(types.RESET_WORK_DAYS_STATS);
		}
	},

	mutations: {
		[types.STORE_VISITS](state, visits) {
			state.visits = [...visits].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
		},

		[types.RESET_VISITS](state) {
			state.visits = [];
		},

		[types.STORE_WORK_DAYS_STATS](state, workDaysStats) {
			state.workDaysStats = workDaysStats;
		},

		[types.RESET_WORK_DAYS_STATS](state) {
			state.workDaysStats = {};
		}
	},

	getters: {
		getVisitById: state => id => state.visits.find(c => c.id === id)
	}
}
